<script setup>
import BasePreferenceTemplate from '@/components/preference/templates/BasePreferenceTemplate.vue'
import PreferenceLogo from '@/components/preference/PreferenceLogo.vue'
import MainInput from '@/components/elements/MainInput.vue'
import MainButton from '@/components/MainButton.vue'

import { withProps } from '@/components/preference/templates/preferenceTemplate.js'

defineProps({ ...withProps() })
defineEmits(['save', 'userEmail', 'update'])
defineOptions({ inheritAttrs: false })
</script>

<template>
  <BasePreferenceTemplate v-bind="{ ...$props, ...$attrs }" @save="$emit('save')" @user-email="$emit('userEmail', $event)" @update="$emit('update')">
    <template #form-step="{ logo, attrs, name, chosenEmail, updateChosenEmail, alertMsg, setEmail }">
      <PreferenceLogo :url="logo" />
      <div class="mx-6 text-center">
        <h1 class="text-2xl font-medium mt-8">{{ attrs?.tag_subject || $t('pref_page.title') || 'Update your preferences' }}</h1>
        <h2 class="text-gray-400">{{ attrs?.tag_pre_name || $t('pref_page.header') || 'for ' }}{{ name }}</h2>
      </div>

      <form class="flex flex-col text-center items-center mt-5 space-y-4" @submit="setEmail($event, chosenEmail)">
        <MainInput
          :id="'email'"
          :model-value="chosenEmail"
          :name="$t('pref_page_email_form.form_title')"
          :type="'email'"
          :style="'primary'"
          :placeholder="$t('pref_page_email_form.form_placeholder').replace('[at]', '@')"
          :value="$attrs.email"
          :error="alertMsg"
          @update:model-value="updateChosenEmail($event)"
        />

        <MainButton :style="'primary'" :attributes="attrs" @click="setEmail($event, chosenEmail)">
          {{ $t('pref_page_email_form.form_save_btn') }}
        </MainButton>
      </form>
    </template>

    <template #action-buttons="{ attrs, disabled, updateGlobal }">
      <div class="mt-8 flex w-full justify-center space-x-5">
        <MainButton v-if="attrs.unsubscribe_all" data-test="unsubscribe-all-button" :style="'secondary'" @click="!disabled ? updateGlobal() : null">
          {{ $t('pref_page.unsubscribe_btn') }}
        </MainButton>
        <MainButton v-if="!attrs?.auto_save" :style="'primary'" :attributes="attrs" @click="$emit('save')">
          {{ $t('pref_page.save_btn') }}
        </MainButton>
      </div>
    </template>
  </BasePreferenceTemplate>
</template>

<style>
.error-text {
  color: red;
  font-size: medium;
  margin-top: 0.5rem;
}
</style>
